import React from 'react';
import './LandingPage.css';

function LandingPage() {
  const currentYear = new Date().getFullYear();

  return (
    <div className="landing-page">
      <header>
        <h1>OMGChatrooms</h1>
        <p>Connect with others via video call and text</p>
        <p>Coming Soon...</p>
      </header>

      <section className="why-us">
        <h2>Why Choose Us?</h2>
        <div className="why-us-content">
          <ul>
            <li>
              <i className="fa fa-check"></i> Simple - No Sign-in required
            </li>
            <li>
              <i className="fa fa-check"></i> Anonymous - Your personal data is never tracked
            </li>
            <li>
              <i className="fa fa-check"></i> Secure - AI-powered moderation for safe conversations
            </li>
          </ul>
        </div>
      </section>

      <footer>
        <div className="copyright">
          &copy; {currentYear} OMGChatrooms. All rights reserved.
        </div>
      </footer>
    </div>
  );
}

export default LandingPage;